import { createAppInstance } from "#/decision_tree_viewer";

let app;

function mountInitialViewer() {
  const detail = { selector: "#decision-tree-viewer" };
  const event = new CustomEvent("decision-tree-viewer:mount", { detail });
  document.dispatchEvent(event);
}

async function mountViewer(event) {
  const { selector, props } = event.detail;
  const container = document.querySelector(selector);

  if (container) {
    if (app) {
      app.unmount();
    }

    app = await createAppInstance(props ?? JSON.parse(container.dataset.vueProps));
    app.mount(container);
  }
}

function unmountViewer() {
  app.unmount();
  app = null;
}

document.addEventListener("DOMContentLoaded", mountInitialViewer);
document.addEventListener("decision-tree-viewer:mount", mountViewer);
document.addEventListener("decision-tree:allow-booking", unmountViewer);
